import {useContext} from 'react';
import ConfirmModalContext, {
  ConfirmModalContextType,
} from '@/context/ConfirmModalContext';

export function useConfimationModal() {
  return useContext<ConfirmModalContextType>(ConfirmModalContext);
}